<template>
  <div class="exercise-choice-root">
    <!-- 题干 -->
    <section class="judge-question-con">
      <!-- 拼音类型无需组件 -->
      <div v-if="questionKey == 'Pinyin'" class="practice-pinyin">{{ currentItem?.pinyin }}</div>

      <component
        v-else
        :is="questionKey"
        :currentItem="currentItem"
        :soundUrl="currentItem?.tts_url"
      >
      </component>
    </section>
    <!-- 选项 -->
    <section class="judge-question-con" v-if="answerOption">
      <div v-if="answerKey == 'Pinyin'" class="practice-pinyin">
        {{ answerOption.pinyin }}
      </div>
      <component
        v-else
        :is="answerKey"
        :currentItem="answerOption"
        :soundUrl="answerOption.tts_url"
      >
      </component>
    </section>

    <section class="judge-answer-con">
      <div
        v-for="item in checkConList"
        :key="item.key"
        class="check-con"
        :class="{
          'success-check-con': checkAnswer && item.status == 'success',
          'error-check-con': checkAnswer && item.status == 'failed',
        }"
      >
        <template>
          <img
            v-if="checkAnswer && item.status == 'success'"
            src="@/assets/images/free-practice/check_right_sml.png"
            class="right-icon"
          />
          <img
            v-else-if="checkAnswer && item.status == 'failed'"
            src="@/assets/images/free-practice/check_wrong_sml.png"
            class="wrong-icon"
          />
          <div v-else class="check-circle" @click="clickCheckCon(item)"></div>
        </template>
        <img :src="item.iconSrc" class="juedge-check-icon" />
      </div>
    </section>
  </div>
</template>
<script>
import Meaning from './meaning'
import Sound from './singlePlayer'
import Characters from './characters.vue'
export default {
  props: {
    questionKey: {
      type: String,
      default: 'Meaning',
    },
    answerKey: {
      type: String,
      default: 'Sound',
    },
    currentItem: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    currentItem: {
      handler() {
        this.checkAnswer = false
        this.checkConList.forEach((item) => {
          item.status = null
        })
        this.answerOption = this.currentItem.option[0]
      },
      immediate: true,
    },
  },
  data() {
    return {
      checkAnswer: false,
      checkConList: [
        {
          key: 'right',
          status: null,
          iconSrc: require('@/assets/images/free-practice/judge_right.png'),
        },
        {
          key: 'wrong',
          status: null,
          iconSrc: require('@/assets/images/free-practice/judge_wrong.png'),
        },
      ],
      rightOption: null,
      wrongOption: null,
      answerOption: '',
    }
  },
  methods: {
    clickCheckCon(item) {
      if (this.checkAnswer) {
        return
      }
      // right wrong
      let check = false
      let presentOptionCorrect = this.currentItem?.option[0]?.correct //true:展示答案是正确的；fase:展示答案是干扰项
      console.log(presentOptionCorrect, 'presentOptionCorrect')
      if (presentOptionCorrect) {
        // option 0 是正确的
        // 选对得分
        check = item.key == 'right' ? true : false
        // 将正确与错误option赋值
        this.rightOption = this.currentItem?.option[0]
        this.wrongOption = this.currentItem?.option[1]
      } else {
        // option 0 是干扰的
        // 选错，得分
        check = item.key == 'wrong' ? true : false
        // 将正确与错误option赋值
        this.rightOption = this.currentItem?.option[1]
        this.wrongOption = this.currentItem?.option[0]
      }
      console.log(check, '做对了吗')
      console.log(this.rightOption, 'this.rightOption')
      console.log(this.wrongOption, 'this.wrongOption')
      if (check) {
        // 回答正确
        // 当前选中项绿色
        item.status = 'success'
        // 保存答案
        this.$emit('judgeGetAnswer', { id: this.rightOption.id, correct: true })
      } else {
        // 回答错误
        // 当前选项红色
        item.status = 'failed'
        // 另一选项绿色
        this.checkConList.forEach((checkItem) => {
          if (checkItem.status == null) {
            checkItem.status = 'success'
          }
        })
        this.$emit('judgeGetAnswer', { id: this.wrongOption.id, correct: false })
      }
      this.checkAnswer = true
    },
  },
  beforeDestroy() {
    this.$player.pause()
    cancelAnimationFrame(this.animationId)
  },
  components: {
    Meaning,
    Sound,
    Characters,
  },
}
</script>
<style lang="scss">
@import '../styles/practiceExercise.scss';
.exercise-choice-root {
  .judge-question-con {
    display: flex;
    align-items: center;
    margin: 44px auto;
    width: 660px;
    min-height: 80px;
    justify-content: center;
  }
  .judge-answer-con {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 0 40px;
    margin-top: 14px;
  }
  .juedge-check-icon {
    width: 24px;
    height: 24px;
  }
}
</style>
